"use client";
import React from "react";

export class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error("CAUGHT ERROR:", error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-ocean-900 p-8 text-center text-foam">
          <h1 className="mb-4 text-2xl font-bold text-red-400">Something went wrong</h1>
          <p className="mb-8 max-w-md text-sky-200/70">
            A critical error occurred while loading the map. Try refreshing the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-md bg-sky-600 px-4 py-2 font-medium text-white transition hover:bg-sky-500"
          >
            Refresh Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
